import React, { useState } from "react";
import { CgMenuLeftAlt } from "react-icons/cg";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaUser } from "react-icons/fa6";
import logo from "../assests/logo.png";
import { IoClose } from "react-icons/io5";
import { motion } from "framer-motion";
import { SchedulePost } from "./btn/SchedulePost";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white text-primary shadow-2xl">
      <div className="container mx-auto  px-6 py-2.5 flex justify-between items-center">
        {/* Logo */}
        <div className="font-bold">
          <a href="/">
            <img
              src={logo}
              alt="MyLogo"
              className="h-8 sm:h-8 md:h-8 lg:h-8"
            />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6 items-center">
          {/* <a href="/" className="inline-flex items-center">
            <MdKeyboardArrowRight className="w-8 h-8" /> Home
          </a>

          <a href="/gallery" className="inline-flex items-center">
            <MdKeyboardArrowRight className="w-8 h-8" />
            Gallery
          </a>

          <a href="/appointment" className="inline-flex items-center">
            <MdKeyboardArrowRight className="w-8 h-8" /> Appointment
          </a> */}


          <SchedulePost isHeader={true}/>

          {/* <button
            className="w-8 h-8"
            class="inline-flex gap-2 items-center text-white bg-primary  hover:bg-opacity-80 font-medium rounded-3xl px-5 py-2.5 me-2 mb-2 focus:outline-none"
          >
            <FaUser /> Login
          </button> */}
        </nav>

        {/* Mobile Hamburger Icon */}
        {/* <button
          onClick={toggleMenu}
          className="md:hidden flex items-center space-x-2"
        >
          <CgMenuLeftAlt className="text-textPrimary rotate-180 w-8 h-8" />
        </button> */}
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div
          className="w-full bg-white z-10 shadow-md absolute top-0 left-1/2 -translate-x-1/2 md:hidden  py-2.5 pb-12 "
          initial={{ opacity: 0 }} // Initial state (hidden)
          animate={{ opacity: isMenuOpen ? 1 : 0 }} // Fade-in when menu is open
          exit={{ opacity: 0 }} // Fade-out when menu is closed
          transition={{
            duration: 0.3,
            ease: "easeIn", // Apply ease-in transition for smooth effect
          }} // Duration of the fade transition
        >
          <div className="container mx-auto">
            <div className="px-2 flex justify-between items-center">
              {/* Logo */}
              <div className="font-bold">
                <a href="/">
                  <img
                    src={logo}
                    alt="MyLogo"
                    className="h-8 sm:h-10 md:h-12 lg:h-8"
                  />
                </a>
              </div>
              <IoClose
                onClick={toggleMenu}
                className="w-8 h-8 text-textPrimary"
              />
            </div>
            <nav className="flex flex-col space-y-6 mt-8">
              <a href="/" className="inline-flex items-center">
                <MdKeyboardArrowRight className="w-8 h-8 text-left" /> Home
              </a>

              <a href="/gallery" className="inline-flex items-center">
                <MdKeyboardArrowRight className="w-8 h-8 text-left" />
                Gallery
              </a>

              <a href="/appointment" className="inline-flex items-center">
                <MdKeyboardArrowRight className="w-8 h-8 text-left" />{" "}
                Appointment
              </a>
              <button className="w-full inline-flex gap-2 items-center text-white justify-center bg-primary  hover:bg-opacity-80 font-medium rounded-3xl px-5 py-2.5 me-2 mb-2 focus:outline-none">
                <FaUser /> Login
              </button>
            </nav> 
          </div>
        </motion.div>
      )}
    </header>
  );
}

export default Header;
